import 'font-awesome/css/font-awesome.min.css';
import { Link } from 'react-router-dom';
import SerrviceList from './../../data/services.json';
const Service = () => {
  return (
    <section className="service" id="services">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mt-2">
            <div className="section-title">
              <h2>Our Services</h2>
            </div>
          </div>
          {SerrviceList.map((service) => (
            <div className="col-lg-4 col-md-6" key={service.id}>
              <div className="service-item">
                <i className={service.icon} aria-hidden="true" />
                {/* <img className="head-image" src={service.image} alt={service.title} /> */}
                <div className="service-card">
                  <h3>{service.title}</h3>
                  <p dangerouslySetInnerHTML={{ __html: service.short }} />
                  <Link className="btn btn-primary btn-sm" to={`services/${service.slug}`}> Learn More
                  </Link>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

  );
};
export default Service;